//gyms/api

import {API} from "../../../backend";
// import config from "../../../config";
import client from "../../../clients";
import { objectToQueryString } from "../../../lib/utils";

export const getUnAuthBranch = (branchId) =>{
    return fetch(`${API}/branch/${branchId}?${client.config.unAuthParam}`,{
        method:'GET',
        headers:{
            Accept:'application/json',
        },
    }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}
export const updateBranchPublicAccess = (userId, token, body) => {
    return fetch(`${API}/branch/public-access/${userId}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
    })
    .then(response => response.json())
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getBranch = (userId, token,branchId) => {
    return fetch(`${API}/branch/${userId}/${branchId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getBranchNoAuth = (userId, token,branchId) => {
    return fetch(`${API}/branch/${branchId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};




export const createBranch=(userId,token,gymId,branch)=>{
    return fetch(`${API}/create/branch/${userId}/${gymId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(branch)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const updateBranch=(userId,token,branchId,branch)=>{
    return fetch(`${API}/update/branch/${userId}/${branchId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(branch)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const updateBranchInfo=(userId,token,branchId,branch)=>{
    return fetch(`${API}/update/branch-info/${userId}/${branchId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(branch)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const getAllBranches=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/branches/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getBranchCount = (userId, token, query) => {
    const  str=objectToQueryString(query)
    return fetch(`${API}/branches/count/${userId}?${str}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const changeBranchStatus =(userId,token,activationStatus,body)=>{
    return fetch(`${API}/change/branch/status/${userId}/${activationStatus}`,{
        method:"PUT",
        headers:{
            Accept: "application/json",
            "Content-type": "application/json",
            Authorization: `Bearer ${token}` 
        },
        body:JSON.stringify(body)
    }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


//media record api

export const getMediaRecords = (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/media-records/${userId}?${str}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getMediaRecordCount = (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/media-records/count/${userId}?${str}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const removeMediaRecords = (userId, token , body) =>{
    return fetch(`${API}/remove/media-records/${userId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getMediaRecord = (userId, token, mediarecordId) =>{
    return fetch(`${API}/media-record/${userId}/${mediarecordId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}



// published media record api



export const getPublishMediaRecords = (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/published-media-records/${userId}?${str}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getPublishMediaRecordCount = (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/published-media-records/count/${userId}?${str}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const uploadMediaRecord = (userId, token, branchId, formData) =>{
    const url = branchId?`${API}/upload/media-record/${userId}/${branchId}`:`${API}/upload/media-record/${userId}`;
    return fetch(url,{
        method: "POST",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
        },
        body:formData
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const publishMediarecord = (userId, token, branchId, body) =>{
    const url = branchId?`${API}/publish/media-record/${userId}/${branchId}`:`${API}/publish/media-record/${userId}`;
    return fetch(url,{
        method: "POST",
        headers:{
          Accept: "application/json",
          'Content-type':"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getPublishMediaRecord = (userId, token, publishmediarecordId) =>{
    return fetch(`${API}/published-media-record/${userId}/${publishmediarecordId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getActivePublishedRecords = (userId, token, branchId,query)=>{
    const  str=objectToQueryString(query)
    const url = branchId?`${API}/active/published-records/${userId}/${branchId}?${str}`:`${API}/active/published-records/${userId}?${str}`;
    return fetch(url , {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const removePublishedMediaRecords = (userId, token, branchId, body) =>{
    const url = branchId?`${API}/remove/published-mediarecords/${userId}/${branchId}`:`${API}/remove/published-mediarecords/${userId}`;
    return fetch(url,{
        method: "POST",
        headers:{
          Accept: "application/json",
          'Content-type':"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

//begining - slack api

export const getSlackUrls= (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/slack-urls/${userId}?${str}`,{
        method:"GET",
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getSlackUrlCount= (userId, token, query) =>{
    const  str=objectToQueryString(query)
    return fetch(`${API}/slack-url/count/${userId}?${str}`,{
        method:"GET",
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const saveSlackUrls= (userId, token, branchId, body) =>{
    return fetch(`${API}/save/slack-urls/${userId}/${branchId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


//end -- slack api

export const getMemberBranchActivityDetails = (userId, token, branchId,query)=>{
    let queryString = objectToQueryString(query);
    return fetch(`${API}/branch/activity-details/${userId}/${branchId}?${queryString}`,{
        method:"GET",
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


//sms 

export const enableDiableBranchSms = (userId, token, body) =>{
    return fetch(`${API}/branch/sms-enable-disable/${userId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


//whatsapp
export const enableDiableBranchWhatsApp = (userId, token, body) =>{
    return fetch(`${API}/branch/whatsapp-enable-disable/${userId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

//feature add
export const addRemoveFeatureToBranch = (userId, token, body) =>{
    return fetch(`${API}/branch/add-remove-feature/${userId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const hideAndUnHideToBranch = (userId, token, body) =>{
    return fetch(`${API}/branch/hide-unhide-wp-assets/${userId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}



export const updateBranchConfig = (userId, token,branchId, body) =>{
    return fetch(`${API}/update/branch-config/${userId}/${branchId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}





export const updateBranchRoleFeatureAccess = (userId, token,branchId, body) =>{
    return fetch(`${API}/update/branch-role-feature-access/${userId}/${branchId}`,{
        method:"PUT",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const createBranchV2 = (userId, token, body) =>{
    return fetch(`${API}/v2/create/branch/${userId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const updateBranchLogo = (userId, token, gymProfileImage) => {
    return fetch(`${API}/gym/profile-update/${userId}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`
        },
        body: gymProfileImage
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
} 


export const updateBranchSystemAccess = (userId,token,body) =>{
    return fetch(`${API}/branch/update/system-access/${userId}`,{
        method:"PUT",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const generateEnquiryQR = (userId, token, branchId) => {
    return fetch(`${API}/enquiry/qr-code/${userId}/${branchId}`,{
        method:'GET',
        headers:{
            Accept:'application/json',
            "Content-Type":'application/json',
            Authorization:`Bearer ${token}`
        },
    }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


// Access Key Management
export const generateAccessKey = (userId, token, branchId) =>{
    return fetch(`${API}/branch/generate-access-key/${userId}/${branchId}`,{
        method:"POST",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const deleteAccessKey = (userId, token, branchId) =>{
    return fetch(`${API}/branch/delete-access-key/${userId}/${branchId}`,{
        method:"DELETE",
        headers:{
            Accept:"application/json",
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}